import { render } from "./wei.vue?vue&type=template&id=76910af2&scoped=true"
import script from "./wei.vue?vue&type=script&lang=js"
export * from "./wei.vue?vue&type=script&lang=js"

import "./wei.vue?vue&type=style&index=0&id=76910af2&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76910af2"]])

export default __exports__